<template>
  <div v-if="article" class="article-box">
    <div class="mwarp wangEditor-containe html-content" style="margin: 0 auto;">
      <div
        class="wangEditor-txt"
        style="margin-top: 0;padding-top:0;padding-bottom:0;"
      >
        <div v-html="article.content"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  // props: ['article'],
  props: {
    article: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
<style lang="less">
@import url(../../project.less);
section {
  max-width: 100%;
}
.html-content {
  position: relative;
  overflow: hidden;
  color: #3e3e3e;
  max-width: 100% !important;
  box-sizing: border-box !important;
  -webkit-box-sizing: border-box !important;
  word-wrap: break-word !important;
}
</style>
